import { UIText2 } from '@cian/ui-kit';

import * as styles from './Type.css';

export interface ITypeProps {
  texts: (string | null | undefined)[];
}

export function Type({ texts }: ITypeProps) {
  if (!texts) {
    return null;
  }

  return (
    <div className={styles['container']}>
      {texts.map((text, index) => {
        if (text && index === 0) {
          return (
            <UIText2 key={index} color="text-secondary-default">
              {text}
            </UIText2>
          );
        }
        if (text) {
          return (
            <UIText2 key={index} color="text-secondary-default">
              {text}
            </UIText2>
          );
        }

        return null;
      })}
    </div>
  );
}
